module.exports = __webpack_public_path__ + "static/media/pulp-fiction-wtf.b65504db.gif";